'use strict';

import loadWhenNeeded from '../Utils/LoadWhenNeeded';

/**
 * @classname FairIntroMarquee
 * @classdesc フェア紹介セクションの写真マーキー（requestAnimationFrameで位置を直接制御し、CSSアニメーションのブラウザ依存の途切れを回避する）
 */
export default class FairIntroMarquee {
	/**
	 * @constructor
	 * @param {jQuery} $e - .block--photo-track
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._track = $e[0];
		this._position = 0;
		this._lastTime = null;
		this._groupWidth = 0;
		this._speed = 0;
		this._frameId = null;
		this._isVisible = !('IntersectionObserver' in window);

		// 写真は従来どおりload後（または画面内に入った時）に読み込む。
		// 動くトラックではなく固定の表示枠を監視する。
		const viewport = this._track.parentElement;
		loadWhenNeeded(viewport, () => {
			this._track.querySelectorAll('img[data-src]').forEach((img) => {
				img.loading = 'eager';
				img.src = img.dataset.src;
				img.removeAttribute('data-src');
			});
		});

		const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		if (reduceMotion || !this._track.firstElementChild) {
			return;
		}

		this.measure();
		window.addEventListener('resize', () => this.measure());
		document.addEventListener('visibilitychange', () => this.updatePlayback());
		if ('IntersectionObserver' in window) {
			this._observer = new IntersectionObserver((entries) => {
				this._isVisible = entries.some((entry) => entry.isIntersecting);
				this.updatePlayback();
			});
			this._observer.observe(viewport);
		}
		this.updatePlayback();
	}

	updatePlayback() {
		if (this._isVisible && !document.hidden) {
			if (this._frameId !== null) return;
			// 再表示時は止めた位置から再開し、画面外にいた時間で飛ばさない。
			this._lastTime = null;
			this._frameId = requestAnimationFrame((time) => this.tick(time));
		} else {
			cancelAnimationFrame(this._frameId);
			this._frameId = null;
			this._lastTime = null;
		}
	}

	/**
	 * グループ幅と速度を計測する（元のCSSアニメーションと同じく、グループ1個分の距離を38秒で移動）
	 *
	 * @memberof FairIntroMarquee
	 * @return undefined
	 */
	measure() {
		const firstGroup = this._track.firstElementChild;
		this._groupWidth = firstGroup ? firstGroup.offsetWidth : 0;
		this._speed = this._groupWidth / 38;
		if (this._groupWidth > 0) {
			this._position %= this._groupWidth;
		}
	}

	/**
	 * 毎フレームtransformを更新する
	 *
	 * @memberof FairIntroMarquee
	 * @param {number} time
	 * @return undefined
	 */
	tick(time) {
		if (this._lastTime === null) {
			this._lastTime = time;
		}
		const delta = (time - this._lastTime) / 1000;
		this._lastTime = time;

		this._position += this._speed * delta;
		if (this._groupWidth > 0 && this._position >= this._groupWidth) {
			// 画面外へ出たグループを右端へ移し、見た目の位置は連続させる
			this._position -= this._groupWidth;
			this._track.appendChild(this._track.firstElementChild);
			this.measure();
		}
		this._track.style.transform = `translate3d(${-this._position}px, 0, 0)`;

		this._frameId = requestAnimationFrame((t) => this.tick(t));
	}
};
